import api from '@/apis/fr/frFormulaCustomAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('FrFormulaCustom', api);

const state = {
  ...crud.state,
  _config: {
    table: 'fr_formula_custom',
    field: {
      key: 'fr_formula_custom_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Update multiple
   * nmtuan4 15.9.2022
   */
  async addAndUpdateMultiple(context, param) {
    let res = await api.addAndUpdateMultiple(param);

    //HTHIEP 08.07.2022: Update lại state khi cập nhật dữ liệu
    context.commit('setItems', []);
    return res;
  },

  /**
   * Get DefaultData
   * HTHAI 07.06.2022
   */
  async defaultData(context, param) {
    let res = await api.defaultData(param);
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
